module.exports = __webpack_public_path__ + "img/md-browsers.5b3027fe.svg";